module.exports = __webpack_public_path__ + "static/img/PE.b7074eae.svg";